import PropTypes from 'prop-types';
import React from 'react';
import DealSideRow from './DealSideRow';

function DealCampaignCard({ campaign, teamId }) {
  if (!campaign) return null;

  const percent = Number(campaign.progress_percentage) || 0;
  const clamped = Math.max(0, Math.min(100, percent));
  const dates = [campaign.start_date, campaign.end_date].filter(Boolean).join(' → ');

  return (
    <div className="deal-side-card">
      <div className="deal-side-card-title">Campaign</div>
      <div className="deal-side-donor">
        {campaign.id ? (
          <a href={`/teams/${teamId}/giving/${campaign.id}`} className="deal-side-donor-name">
            {campaign.name}
          </a>
        ) : (
          <span className="deal-side-donor-name">{campaign.name}</span>
        )}
        {(campaign.status || dates) && (
          <div className="deal-side-donor-org">
            {[campaign.status, dates].filter(Boolean).join(' · ')}
          </div>
        )}
      </div>

      <DealSideRow label="Goal" value={campaign.goal} />
      <DealSideRow label="Raised so far" value={campaign.raised} />
      <DealSideRow label="Pipeline" value={campaign.pipeline} />

      <div className="deal-campaign-progress">
        <div className="deal-campaign-progress-track">
          <div className="deal-campaign-progress-fill" style={{ width: `${clamped}%` }} />
        </div>
        <div className="deal-campaign-progress-pct">{percent}% to goal</div>
      </div>
    </div>
  );
}

DealCampaignCard.propTypes = {
  campaign: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    name: PropTypes.string,
    status: PropTypes.string,
    start_date: PropTypes.string,
    end_date: PropTypes.string,
    goal: PropTypes.string,
    raised: PropTypes.string,
    pipeline: PropTypes.string,
    progress_percentage: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  }),
  teamId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
};

export default DealCampaignCard;
